import React, { useEffect, useState } from 'react'

import allImgPaths from "../../assets/images";
import { emptyReviewSpaceCardTexts, emptyBoardCardTexts } from 'utils/constant';
import useAppState from 'context/useAppState';

const EmptyReviewSpace = ({ cardName, blockName = null, openFeteFromBoard }: any) => {

	const { setState: setEventDataState, sendButtonRef } = useAppState("eventData");
	const { cards: cardList, fetchCardPrompt } = useAppState("cardWrapper");
	const { setState: setChatBoxState } = useAppState("chatBox");
	const cardHtmlTexts = emptyReviewSpaceCardTexts
	const blockHtmlTexts = emptyBoardCardTexts

	const [cardHtml, setCardHtml] = useState<any>(null)

	useEffect(() => {
		if (cardName || blockName) {
			setCardHtmlText()
		}
	}, [cardName])

	const setCardHtmlText = () => {
		let cardData;

		if (cardName) {
			cardData = cardHtmlTexts.find((cd: any) => cd?.card?.toLowerCase() == cardName?.toLowerCase())
		}
		if (blockName) {
			cardData = blockHtmlTexts.find((cd: any) => cd?.block?.toLowerCase() == blockName?.toLowerCase())
		}

		if (cardData) {
			setCardHtml(cardData)
		}
	}

	const handleEmptyReviewSpaceClick = (actionText: any, promptKey: '') => {
		if (actionText) {
			setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, brainStormText: actionText, bestActionPrompt: promptKey })
			sendButtonRef.current = true;
		}
	}

	const handleEmptyBoardClick = async (actionText: any, cardName: any, isBrainstorm: boolean, promptKey: any) => {
		const card = cardList.find((cd: any) => cd?.title?.toLowerCase() == cardName?.toLowerCase())

		const prompt = await fetchCardPrompt(card?.prompt_id);
		if (prompt?.name) {
			setChatBoxState({ cardPrompt: prompt })
		}

		if (isBrainstorm) {
			if (actionText) {
				setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, brainStormText: actionText, bestActionPrompt: promptKey })
				openFeteFromBoard(actionText, card?._id, isBrainstorm)
				sendButtonRef.current = true;
			}
		} else {
			openFeteFromBoard(actionText, card._id, isBrainstorm)
		}
	}

	return (
		<>
			{
				cardName &&
				<div className="text-center absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-[520px] py-20">
					<img className="mb-5 mx-auto" src={allImgPaths.reviewSpaceEmptyState} alt="" />

					<p className='font-interMedium text-base text-[#344054] pb-1.5'>
						{cardHtml?.fontMessage}
					</p>

					{
						cardHtml?.textMessage && <p className='text-base font-normal text-[#344054] mb-5'>
							{cardHtml.textMessage}
						</p>
					}

					<div className="flex gap-x-3 items-center justify-center">
						{
							(cardHtml?.buttons || []).map((button: any, index: number) => (
								<button key={index}
									className="!px-5 !py-2 whitespace-nowrap border border-[#A59DFB] text-[#1e0af5] font-interMedium rounded-lg hover:bg-[#E8E6FE]"
									onClick={() => handleEmptyReviewSpaceClick(button?.actionText || '', button?.promptKey || '')}>
									{button.text}
								</button>
							))
						}
					</div>
				</div>
			}

			{
				blockName &&
				<div className="w-full">
					<img className="mx-auto mb-5" src={allImgPaths.boardEmptyState} alt="" />
					<p className="font-interSemiBold text-base text-[#344054] pb-1.5 text-center">
						{cardHtml?.fontMessage}
					</p>
					{
						cardHtml?.textMessage && <p className="text-base font-normal text-[#344054] mb-5 text-center">
							{cardHtml.textMessage}
						</p>

					}

					<div className="flex gap-x-4 items-center justify-center">
						{
							(cardHtml?.buttons || []).map((button: any, index: number) => (
								<button key={index}
									className='submit-btn-blue !px-3 !py-2 whitespace-nowrap !bg-white border !border-[#A59DFB] !text-[#1e0af5] flex items-center gap-x-2 hover:!bg-[#E8E6FE]'
									onClick={() => handleEmptyBoardClick(button?.actionText || '', button?.card, button.isBrainstorm, button?.promptKey || '')}
								>
									<img className='w-5 h-5' src={button?.isBrainstorm ? allImgPaths.brainstromIcon : allImgPaths.reviewSelectedIcon} alt="" />
									{button.text}
								</button>
							))
						}

					</div>
				</div>
			}
		</>
	)
}

export default EmptyReviewSpace
